{
  "loading": "Se încarcă...",
  "placeholder": "Selectați…"
}
